import { Gift } from 'lucide-react'

import type { OrderGift } from '@/lib/api/sales-order-api'
import { FormSection } from '@/components/forms/form-section'
import { formatVnd } from '@/lib/format'
import { m } from '@/lib/paraglide/messages'

function GiftRow({ label, value }: { label: string; value: React.ReactNode }) {
    return (
        <div className="flex justify-between gap-4">
            <span className="text-muted-foreground shrink-0">{label}</span>
            <span className="min-w-0 text-right break-words">{value}</span>
        </div>
    )
}

/** Đơn quà web (§14.21): lời nhắn, ẩn giá trên phiếu / tem, ship người đặt đã
 *  trả trước. ERP không tự hoàn ship khi huỷ / hoàn — nhân viên xử lý tay. */
export function OrderGiftCard({ gift }: { gift?: OrderGift }) {
    if (!gift) return null
    const shipOwed = gift.shipping_prepaid
        ? Math.max(gift.shipping_fee - gift.shipping_paid, 0)
        : 0
    return (
        <FormSection
            icon={<Gift />}
            title={m.order_gift_title()}
            hint={
                gift.shipping_prepaid ? m.order_gift_refund_hint() : undefined
            }
        >
            <div className="space-y-1.5 text-sm">
                <GiftRow
                    label={m.order_gift_message()}
                    value={gift.message || m.order_gift_no_message()}
                />
                <GiftRow
                    label={m.order_gift_print()}
                    value={
                        gift.hide_price
                            ? m.order_gift_hide_price()
                            : m.order_gift_show_price()
                    }
                />
                {gift.shipping_prepaid && (
                    <GiftRow
                        label={m.order_gift_shipping_prepaid()}
                        value={
                            shipOwed > 0
                                ? m.order_gift_shipping_partial({
                                      paid: formatVnd(gift.shipping_paid),
                                      fee: formatVnd(gift.shipping_fee),
                                  })
                                : formatVnd(gift.shipping_paid)
                        }
                    />
                )}
            </div>
        </FormSection>
    )
}
